<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <div class="modal-title">
            <!-- <h6 *ngIf="Model && Model.length > 0" translate>LBL.OPEN_CALLS</h6> -->
            <h6 *ngIf="((Model && Model.length == 0) && (WOModel && WOModel.length == 0))" translate>LBL.PLEASE_CONFIRM</h6>
        </div>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="ModalContainer" [ngSwitch]="StaffDetails.IsLoggedIn" *ngIf="!isArray(StaffDetails) && ((Model && Model.length == 0) && (WOModel && WOModel.length == 0))">
            <div *ngSwitchCase="true">
                <span>{{'LBL.LOGOUT_CONFIRM' | translate}} {{StaffDetails.Description}}?</span>

            </div>
            <div *ngSwitchCase="false">{{'LBL.LOGIN_CONFIRM' | translate}} {{StaffDetails.Description}}?</div>
        </div>
        <div class="ModalContainer" [ngSwitch]="IsLoginAction" *ngIf="isArray(StaffDetails) && ((Model && Model.length == 0) && (WOModel && WOModel.length == 0))">
            <div *ngSwitchCase="true">
                <span translate>LBL.CONFIRM_START_SHIFT</span>
            </div>
            <div *ngSwitchCase="false" translate>LBL.CONFIRM_END_SHIFT</div>
        </div>
        <div *ngIf="((Model && Model.length > 0) || (WOModel && WOModel.length > 0))">

            <div class="colTabs">
                <div class="">
                    <ul class="nav nav-tabs" style="padding-left: 0px;">
                        <li
                            class="nav-item"
                        >
                            <a
                                class="nav-link"
                                [ngClass]="{'active': TabID == 1,'disabled': Model && Model.length == 0}"
                                (click)="TabID = 1"
                                ><span translate>LBL.OPEN_CALLS</span></a
                            >
                        </li>
                        <li class="nav-item" *ngIf="HasMNTLicense">
                            <a
                                class="nav-link"
                                [ngClass]="{'active': TabID == 2,'disabled': WOModel && WOModel.length == 0}"
                                (click)="TabID = 2"
                            >
                            <!-- ,'disabled': WOModel && WOModel.length == 0 -->
                                <span translate>LBL.OPEN_WOS</span>
                            </a>
                        </li>
                        </ul>
                        </div>
                        </div>
            <div class="grdTable">
                <div class="row no-gutters grdTableHeader" *ngIf="TabID == 1">
                    <div class="col-2 grdHead pl-2"><span class="text-nowrap" translate>LBL.CALL_NO</span></div>
                    <div class="col-3 grdHead"><span translate>LBL.DESCR</span></div>
                    <div class="col-3 grdHead"><span translate>LBL.LOCATION</span></div>
                    <div class="col-4 grdHead"><span translate>LBL.ACTION</span></div>
                </div>
                <div class="row no-gutters grdTableHeader" *ngIf="TabID == 2">
                    <div class="col-2 grdHead pl-2"><span class="text-nowrap" translate>LBL.LBL_WO_NO</span></div>
                    <div class="col-3 grdHead"><span translate>LBL.DESCR</span></div>
                    <div class="col-2 grdHead"><span translate>LBL.LOCATION</span></div>
                    <div class="col-2 grdHead"><span translate>LBL.STATUS</span></div>
                    <div class="col-3 grdHead"><span translate>LBL.ACTION</span></div>
                </div>
                <div  *ngIf="TabID == 1" class="grdBodyScroll">
                    <div *ngFor="let Staff of Model; let staffIndex = index;">
                        <div class="row no-gutters grdTableSubHeader pl-2">{{Staff.StaffName}}</div>
                        <div *ngFor="let row of Staff.OpenCalls;let callIndex = index;" class="row no-gutters grdRow">
                            <div class="col-2 grdCol pl-2">{{row.DisplayCallNo}}</div>
                            <div class="col-3 grdCol">{{row.CallDescription}}</div>
                            <div class="col-3 grdCol">{{row.LocationName}}</div>
                            <div class="col-4 grdCol">
                                <select [(ngModel)]="row.LogoutOption" (change)="ReassignAction(Staff.StaffId, callIndex, row)" class="custom-select" [disabled]="row.WOFromServiceDisabled" [attr.title]="row.WOFromServiceDisabled ? ('LBL.LBL_CONTROLLED_FROM_MNT_WO' | translate) : ''">
                                    <option value="0" translate>ENTITIES.ENTITIES_REASSIGN_SAME_STAFF_AT_NEXT_LOGIN</option>
                                    <option value="1" translate>ENTITIES.ENTITIES_ASSIGN_NEXT_AVAILABLE_STAFF</option>
                                    <option value="2" translate>ENTITIES.ENTITIES_MANUAL_REASSIGN</option>
                                </select>
                                <div class="mt-2" *ngIf="row.AssignedToStaff"><span translate>LBL.REASSIGNED_TO</span> {{row.AssignedToStaff}}</div>
                            </div>
                            </div>
                    </div>
                </div>

                <div  *ngIf="TabID == 2" class="grdBodyScroll">
                    <div *ngFor="let Staff of WOModel; let staffIndex = index;">
                        <div class="row no-gutters grdTableSubHeader pl-2">{{Staff.StaffName}}</div>
                        <div *ngFor="let row of Staff.OpenCalls;let callIndex = index;" class="row no-gutters grdRow">
                            <div class="col-2 grdCol pl-2">{{row.DisplayName}}</div>
                            <div class="col-3 grdCol">{{row.DescriptionName}}</div>
                            <div class="col-2 grdCol">{{row.LocationName}}</div>
                            <div class="col-2 grdCol" translate>{{row.StatusName}}</div>
                            <div class="col-3 grdCol">
                                <select [(ngModel)]="row.LogoutOption" (change)="ReassignAction(row.LeadStaffId, callIndex, row)" class="custom-select">
                                    <option value="1" *ngIf="(row.WorkOrderStatus != workOrderStatuses.Started) && ((!row.JobId && adhocAutoAssignment !== false) || row.JobId) " translate>ENTITIES.ENTITIES_ASSIGN_NEXT_AVAILABLE_STAFF</option>
                                    <option value="2" translate>ENTITIES.ENTITIES_MANUAL_REASSIGN</option>
                                </select>
                                <div class="mt-2" *ngIf="row.AssignedToStaff"><span translate>LBL.REASSIGNED_TO</span> {{row.AssignedToStaff}}</div>
                                <div class="mt-2" *ngIf="row.LogoutOption === 2">
                                    <button type="button" class="btn btn-primary" (click)="ReassignAction(row.LeadStaffId, callIndex, row)" translate>BTN.BTN_REASSIGN</button>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <div *ngIf="((Model && Model.length > 0) || (WOModel && WOModel.length > 0))">
            <button type="button" class="btn btn-primary mr-2" (click)="DisableModalOpenEvent = false; LoginLogout()" translate>BTN.BTN_PROCEED</button>
            <button type="button" class="btn btn-secondary" (click)="d('dismiss')" translate>BTN.BTN_CANCEL</button>
        </div>
        <div *ngIf="Model && Model.length == 0 && WOModel && WOModel.length == 0">
            <button type="button" class="btn btn-primary mr-2" (click)="DisableModalOpenEvent = false; LoginLogout()" translate>BTN.BTN_YES</button>
            <button type="button" class="btn btn-secondary" (click)="d('dismiss')" translate>BTN.BTN_NO</button>
        </div>
    </div>
</ng-template>
<ManualAssign #manualAssign (SelectedStaffChanged)="onReassigned($event)"></ManualAssign>
